export default __webpack_public_path__ + "static/media/cineonstudio_change.4f7860dd.svg";